import { render, staticRenderFns } from "./SpecimensInactivesModal.vue?vue&type=template&id=5e433ef2&%23default=true"
import script from "./SpecimensInactivesModal.vue?vue&type=script&lang=js"
export * from "./SpecimensInactivesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports